import { WidgetStatus } from "../enums/widget-status.enum";

export class WidgetState {
  readonly status: WidgetStatus;
}